import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {CategoryWiseMessageDto} from '../models/categorywise-message.dto.model';
import * as moment from 'moment';
import { PatientUnreadMessageSummaryDto } from '../models';

@Injectable()
export class MessagesAdapter implements IAdapter<PatientUnreadMessageSummaryDto> {
  adaptToModel(resp: any): PatientUnreadMessageSummaryDto {
    const message: PatientUnreadMessageSummaryDto = {...resp};

    if(message.sender){
      message.sender.username = `${message.sender.firstName} ${message.sender.lastName}`;
    }
    
      if (message.latestCreatedOn) {
        const lastChat=
        new Date(moment(message.latestCreatedOn).add(new Date().getTimezoneOffset(),"m").format("YYYY-MM-DD HH:mm:ss"))
        message.timeElapsed = moment(lastChat).fromNow();
      }
    

    return message;
  }
  adaptFromModel(data: PatientUnreadMessageSummaryDto): any {
    return data;
  }
}
